/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { institutionsAPI } from 'src/api/modules/institutions';
import { usersAPI } from 'src/api/modules/users';
import { topicAPI } from 'src/api/modules/topic';
import { orderOfTheDayAPI } from 'src/api/modules/orderOfTheDay';
import CustomButton from 'src/common/components/CustomButton';
import PageLayout from 'src/common/components/PageLayout';
import UtilInputs from 'src/common/components/UtilInputs';
import { Dialog, Grid, makeStyles } from '@material-ui/core';
import { organsAPI } from 'src/api/modules/organs';
import { sessionsAPI } from 'src/api/modules/sessions';
import notice from 'src/common/components/Notice';
import { useSelector } from 'react-redux';
import { action_buttons, defaultResOrRec, highResForm, filterForm } from './utils/data';
import { filesAPI } from 'src/api/modules/files';
import TablaDocumentos from './TablaDocumentos';
import { getAllOrgans } from 'src/utils/getSubOrganos';
import CloseIcon from 'src/common/utils/TableColumnIcons/CloseIcon';
import moment from 'moment';

const useStyles = makeStyles({
	containerButtons: {
		marginTop: 20,
		width: '100%',
		margin: 0,
	},
	subContainerButtons: {
		flexDirection: 'row',
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
	},
	root: {
		marginTop: 20,
		width: '100%',
		margin: 0,
	},
});

const HighResolutionView = ({ id, setId }) => {
	const classes = useStyles();
	const inpustfile = [1, 2, 3, 4];
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const [items, setItems] = useState([]);
	const [status, setStatus] = useState(false);
	const [loading, setLoading] = useState(false);
	const [resOrRec, setResOrRec] = useState(defaultResOrRec);
	const [validation, setValidation] = useState();
	const [institutions, setInstitutions] = useState([]);
	const [points, setPoints] = useState([]);
	const [recipientsResponsible, setRecipientsResponsible] = useState([]);
	const [recipientsAccompaniment, setRecipientsAccompaniment] = useState([]);
	const [organs, setOrgans] = useState([]);
	const [datesSessions, setdatesSessions] = useState([]);
	const [sessionsPrevious, setSesPrevious] = useState([]);
	const [trackSchedule, settrackSchedule] = useState([]);
	const [flagRender, setFlagRender] = useState(false);
	const [disabledInputs, setDisabledInputs] = useState(false);
	const [disabledDates, setDisabledDates] = useState(false);
	const [organID, setOrganID] = useState();
	const isDev = process.env.REACT_APP_ENVIRONMENT === 'DEV';
	const reduxOrgan = useSelector((state) => state.organsByRol.organs);
	const showEverything = ['ADMINISTRADOR GENERAL', 'SISTEMA', 'RESPONSABLE DE NEGOCIO'];

	const [filters, setFilters] = useState({
		organ: '',
		sessions: '',
		year: new Date().getFullYear(),
		month: '',
	});

	useEffect(() => {
		getInstitutions();
		getOrgans();

		if (id) {
			topicAPI
				.getByResolution(id)
				.then((response) => {
					setValidation(true);
					let data = { ...response.tema };
					if (data.estatus === 'A' || data.estatus === 'AT') setStatus(true);

					let dataSession = { ...response.sesion };
					setOrganID(dataSession.organoId);
					getPreviousSessions(
						dataSession.organoId,
						dataSession.anio,
						dataSession.mes
					);
					let responsiblesItems = [];
					let addresseeRItems = [];
					let accompanimentItems = [];
					let addresseeAItems = [];
					let institucionesID_R = [];
					let institucionesID_A = [];

					if (data.seguimiento.length > 0) {
						data.seguimiento.forEach((item) => {
							if (item.tipo === 'R') {
								responsiblesItems.push({
									value: item.institucionId,
									text: item.institucion,
								});
								institucionesID_R.push(item.institucionId);

								addresseeRItems.push({
									value: item.usuarioId,
									text:
										`${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno} - ` +
										item.perfil,
								});
							}
							if (item.tipo === 'A') {
								accompanimentItems.push({
									value: item.institucionId,
									text: item.institucion,
								});
								institucionesID_A.push(item.institucionId);
								addresseeAItems.push({
									value: item.usuarioId,
									text:
										`${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno} - ` +
										item.perfil,
								});
							}
						});

						getUsersInstitutions(
							institucionesID_R,
							1,
							response.sesion.organoId
						);
						getUsersInstitutions(
							institucionesID_A,
							2,
							response.sesion.organoId
						);

						let uniqueRes = {};
						responsiblesItems = responsiblesItems.filter((item) =>
							uniqueRes[item.value] ? false : (uniqueRes[item.value] = true)
						);

						let uniqueAcc = {};
						accompanimentItems = accompanimentItems.filter((item) =>
							uniqueAcc[item.value] ? false : (uniqueAcc[item.value] = true)
						);
					}

					let dateP;
					let dateL;
					let dateN;

					if (data.fechas !== undefined) {
						if (data.fechas.length > 0) {
							data.fechas.forEach((item) => {
								if (item.tipoFecha === 'P') {
									dateP =
										item.fechaTema.split('-').reverse().join('-') +
										' 00:00:00';
								}
								if (item.tipoFecha === 'L') {
									dateL =
										item.fechaTema.split('-').reverse().join('-') +
										' 00:00:00';
								}
								if (item.tipoFecha === 'N') {
									dateN =
										item.fechaTema.split('-').reverse().join('-') +
										' 00:00:00';
								}
							});
						}
					}

					if (data.sesionId > 0) {
						getPoints(data.sesionId);
					}

					data = {
						...data,
						responsible: responsiblesItems,
						addresseeR: addresseeRItems,
						accompaniment: accompanimentItems,
						addresseeA: addresseeAItems,
						previousSessions: dataSession !== null ? dataSession.id : null,
						sessionDate:
							dataSession.fecha.split('-').reverse().join('-') +
							' 00:00:00',
						filingDate: dateP !== undefined ? dateP : null,
						deadline: dateL !== undefined ? dateL : null,
						notificationDate: dateN !== undefined ? dateN : null,
					};

					setFilters({
						organ: dataSession.organoId,
						sessions: data.sesionId,
						year: dataSession.anio,
						month: dataSession.mes,
					});
					setResOrRec(data);

					//getTrackingSchedule(dataSession?.organoId, dataSession?.fecha, data);

					getArchivos(
						data.asunto,
						response.sesion.organoId,
						response.sesion.migrado,
						dataSession.numero_sesion,
						data
					);
				})
				.catch((e) => {
					notice('Ocurrio un error al mostrar la información');
				});
		} else {
			setValidation(false);
			setResOrRec(defaultResOrRec);
		}

		//VALIDACION DE PERMISOS PARA USUARIOS QUE PUEDEN EDITAR
		if (
			systemLevelRole !== 'ADMINISTRADOR GENERAL' &&
			systemLevelRole !== 'RESPONSABLE DE SEGUIMIENTO' &&
			systemLevelRole !== 'SISTEMA' &&
			systemLevelRole !== 'RESPONSABLE DE NEGOCIO'
		) {
			setDisabledInputs(true);
		}
	}, [id]);

	useEffect(() => {
		if (flagRender) {
			window.location.reload();
		}
	}, [flagRender, setFlagRender]);

	const getArchivos = (asunto, resOrganID, migrated, nameSesion, data) => {
		filesAPI
			.get('RESOLUCIONES', id, migrated)
			.then((x) => {
				if (x && x.length > 0) {
					x = x.slice().reverse();

					let element = [];

					element.push({
						numeroResolucion: asunto,
						organo: resOrganID,
						totalIcons: 4,
						perfil: systemLevelRole,
						userName:
							user.nombre +
							' ' +
							user.apellidoPaterno +
							' ' +
							user.apellidoMaterno,
						dataMinos: builddatosminos(x, id, migrated),
						nameSesion: nameSesion,
						enviadoEnlace: data?.enviadoEnlace,
						enviadoRO: data?.enviadoRO,
						enviadoRS: data?.enviadoRS,
					});

					setItems(element);
				}
			})
			.catch(() => notice('Error al cargar archivos', 'error'));
	};

	const getInstitutions = () => {
		institutionsAPI
			.get('unidadAdministrativa')
			.then((response) => {
				if (response && response.length > 0) {
					let institutionsFlag = [];
					response.forEach((ele) => {
						institutionsFlag.push({
							value: ele.id,
							text: ele.nombre,
						});
					});
					setInstitutions([...(institutionsFlag || [])]);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const getOrgans = () => {
		if (showEverything.includes(systemLevelRole) === true) {
			organsAPI
				.get('get')
				.then((response) => {
					if (response && response.length > 0) {
						setOrgans(getAllOrgans(response));
					}
				})
				.catch((e) => notice('Ocurrio un error al cargar órganos colegiados'));
		} else {
			setOrgans(reduxOrgan);
		}
	};

	const getUsersInstitutions = (institutions, selectedField, organ) => {
		setRecipientsResponsible([]);
		setRecipientsAccompaniment([]);
		usersAPI
			.getByOrganSeveralInstitution(
				organID !== undefined ? organID : organ,
				institutions
			)
			.then((response) => {
				if (response && response.length > 0) {
					let usersInst = [];

					response.forEach((item) => {
						if (
							item.perfil.toUpperCase() === 'ENLACE' ||
							item.perfil.toUpperCase() === 'CONSULTA'
						)
							usersInst.push({
								value: item.id,
								text:
									`${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}  - ` +
									item.perfil,
							});
					});
					switch (selectedField) {
						case 1:
							setRecipientsResponsible(usersInst);
							break;
						case 2:
							setRecipientsAccompaniment(usersInst);
							break;
						default:
							break;
					}
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};

	const getPreviousSessions = (organ, year, month) => {
		setSesPrevious([]);
		setdatesSessions([]);
		sessionsAPI
			.getPreviousSessionsByOrganYear(organ, year, month)
			.then((response) => {
				let newSessPrevious = [];
				let dateSessions = [];
				if (response.codigo === 'SAOC: 500')
					notice(JSON.parse(JSON.stringify(response.mensaje)));
				else if (response && response.length > 0) {
					response.forEach((item) => {
						newSessPrevious.push({
							value: item.id,
							text: item.numero_sesion,
						});
						dateSessions.push({
							idSession: item.id,
							dateSession: item.fecha,
						});
					});
				} else
					notice(
						'No se encontraron sesiones anteriores del órgano seleccionado',
						'warning'
					);
				setSesPrevious([...(newSessPrevious || [])]);
				setdatesSessions(dateSessions);
			})
			.catch((e) => {
				if (e?.response?.data?.mensaje !== undefined)
					notice(JSON.parse(JSON.stringify(e?.response?.data?.mensaje)));
			});
	};

	const getPoints = (session) => {
		orderOfTheDayAPI
			.getPointsOrderOfTheDay(session)
			.then((response) => {
				setPoints([]);
				if (response && response.length > 0) {
					let pointsOfTheDay = [];

					response.forEach((item) => {
						pointsOfTheDay.push({
							value: item.id,
							text: `${item.numeracion} ${item.nombreTema}`,
						});
					});
					setPoints(pointsOfTheDay);
				}
			})
			.catch(() => {
				notice('Ocurrio un error', 'error');
			});
	};
	const getIsDisabledResponsable = (oficio, tarjeta, presentacion) => {
		let isdabled = true;

		if (
			typeof oficio != 'undefined' &&
			typeof tarjeta == 'undefined' &&
			typeof presentacion == 'undefined' &&
			(oficio?.validaSeguimiento === 'APO' || oficio?.validaSeguimiento === 'A')
		)
			isdabled = false;

		if (
			typeof oficio != 'undefined' &&
			typeof tarjeta != 'undefined' &&
			typeof presentacion != 'undefined'
		) {
			if (
				(oficio.validaSeguimiento === 'APO' &&
					tarjeta.validaSeguimiento === 'APO' &&
					presentacion.validaSeguimiento === 'APO') ||
				(oficio.validaSeguimiento === 'A' &&
					tarjeta.validaSeguimiento === 'A' &&
					presentacion.validaSeguimiento === 'A')
			)
				return false;
		}
		return isdabled;
	};
	const builddatosminos = (archivos, idEntidad, migrated) => {
		const oficio = archivos.find((x) => x.tipo === 'O');
		const tarjeta = archivos.find((x) => x.tipo === 'T');
		const presentacion = archivos.find((x) => x.tipo === 'P');
		const adicional = archivos.find((x) => x.tipo === 'A');
		let isSendDisabled = oficio === undefined;

		if (!isSendDisabled) {
			isSendDisabled =
				typeof tarjeta != 'undefined' || typeof presentacion != 'undefined'
					? true
					: false;
			if (isSendDisabled)
				isSendDisabled =
					typeof tarjeta != 'undefined' && typeof presentacion != 'undefined'
						? false
						: true;
		}

		if (systemLevelRole !== 'ENLACE') {
			isSendDisabled = getIsDisabledResponsable(oficio, tarjeta, presentacion);
		}

		const datosMinos = [
			{
				id: oficio ? oficio.id : '',
				idEntidad: idEntidad,
				tipo: 'O',
				entidad: 'RESOLUCIONES',
				estatus: oficio ? oficio.validaSeguimiento : '',
				isSendDisabled: isSendDisabled,
				ruta: 'resoluciones/' + idEntidad + '/',
				title: 'Oficio',
				nombre: oficio ? oficio.nombre : '',
				message: oficio
					? oficio.rechazos.length > 0
						? 'Motivo de Rechazo: ' + oficio.rechazos[0].mensaje
						: ''
					: '',
			},
			{
				id: tarjeta ? tarjeta.id : '',
				estatus: tarjeta ? tarjeta.validaSeguimiento : '',
				idEntidad: idEntidad,
				isSendDisabled: isSendDisabled,
				tipo: 'T',
				entidad: 'RESOLUCIONES',
				ruta: 'resoluciones/' + idEntidad + '/',
				title: 'Tarjeta',
				nombre: tarjeta ? tarjeta.nombre : '',
				message: tarjeta
					? tarjeta.rechazos.length > 0
						? 'Motivo de Rechazo: ' + tarjeta.rechazos[0].mensaje
						: ''
					: '',
			},
			{
				id: presentacion ? presentacion.id : '',
				estatus: presentacion ? presentacion.validaSeguimiento : '',
				idEntidad: idEntidad,
				isSendDisabled: isSendDisabled,
				tipo: 'P',
				entidad: 'RESOLUCIONES',
				ruta: 'resoluciones/' + idEntidad + '/',
				title: 'Presentación',
				nombre: presentacion ? presentacion.nombre : '',
				message: presentacion
					? presentacion.rechazos.length > 0
						? 'Motivo de Rechazo: ' + presentacion.rechazos[0].mensaje
						: ''
					: '',
			},
			{
				id: adicional ? adicional.id : '',
				idMigrado: adicional.idEntidad,
				isMigrated: migrated,
				versionArchivo: adicional.versionArchivo,
				estatus: adicional ? adicional.validaSeguimiento : '',
				idEntidad: idEntidad,
				isSendDisabled: isSendDisabled,
				tipo: 'A',
				entidad: 'RESOLUCIONES',
				ruta: 'resoluciones/' + idEntidad + '/',
				title: 'Adicionales',
				nombre: adicional ? adicional.nombre : '',
				message: adicional
					? adicional.rechazos?.length > 0
						? 'Motivo de Rechazo: ' + adicional.rechazos[0].mensaje
						: ''
					: '',
			},
		];
		return datosMinos;
	};

	const onreturn = () => {
		setId(null);
	};

	const createData = (isEdit) => {
		setLoading(true);
		if (filters.organ === null || filters.organ === '') {
			return notice(
				'El campo Órgano Colegiado es requerido, favor de seleccionar un órgano colegiado',
				'warning'
			);
		}

		if (filters.sessions === null) {
			return notice(
				'El campo Sesión Anterior es requerido, favor de seleccionar una sesión',
				'warning'
			);
		}

		const dates = [];
		const recipients = [];
		if (resOrRec.addresseeR) {
			resOrRec.addresseeR.forEach((item) => {
				recipients.push({
					usuarioId: item.value,
					tipo: 'R',
					estatusUsuario: 'A',
				});
			});
		}
		if (resOrRec.addresseeA) {
			resOrRec.addresseeA.forEach((item) => {
				recipients.push({
					usuarioId: item.value,
					tipo: 'A',
					estatusUsuario: 'A',
				});
			});
		}
		if (isEdit === false) {
			if (resOrRec.filingDate) {
				let dataDates = {
					fechaTema: moment(resOrRec.filingDate)
						.format('L')
						.toString()
						.replaceAll('/', '-'),
					tipoFecha: 'P',
				};
				dates.push({ ...dataDates });
			}

			if (resOrRec.deadline) {
				let dataDates = {
					fechaTema: moment(resOrRec.deadline)
						.format('L')
						.toString()
						.replaceAll('/', '-'),
					tipoFecha: 'L',
				};
				dates.push({ ...dataDates });
			}
			if (resOrRec.notificationDate) {
				let dataDates = {
					fechaTema: moment(resOrRec.notificationDate)
						.format('L')
						.toString()
						.replaceAll('/', '-'),
					tipoFecha: 'N',
				};
				dates.push({ ...dataDates });
			}
		}

		if (isEdit === true) {
			if (resOrRec.filingDate) {
				let dataDates = {
					fechaTema: moment(resOrRec.filingDate)
						.format('L')
						.toString()
						.replaceAll('/', '-'),
					tipoFecha: 'P',
				};
				dates.push({ ...dataDates });
			}

			if (resOrRec.deadline) {
				let dataDates = {
					fechaTema: moment(resOrRec.deadline)
						.format('L')
						.toString()
						.replaceAll('/', '-'),
					tipoFecha: 'L',
				};
				dates.push({ ...dataDates });
			}
			if (resOrRec.notificationDate) {
				let dataDates = {
					fechaTema: moment(resOrRec.notificationDate)
						.format('L')
						.toString()
						.replaceAll('/', '-'),
					tipoFecha: 'N',
				};
				dates.push({ ...dataDates });
			}
		}
		let resOrRecFlag = {
			...resOrRec,
			seguimiento: [...recipients],
			fechas: [...dates],
			sesionId: filters.sessions,
			notificar: resOrRec.notificar === true ? 'S' : 'N',
		};

		delete resOrRecFlag.responsible;
		delete resOrRecFlag.accompaniment;
		delete resOrRecFlag.addresseeR;
		delete resOrRecFlag.addresseeA;
		delete resOrRecFlag.status;
		delete resOrRecFlag.previousSessions;
		delete resOrRecFlag.filingDate;
		delete resOrRecFlag.sessionDate;
		delete resOrRecFlag.deadline;
		delete resOrRecFlag.notificationDate;

		if (isEdit === true) {
			const id = resOrRecFlag.id;
			delete resOrRecFlag.id;

			topicAPI
				.put(id, { ...resOrRecFlag })
				.then((res) => {
					if (res.codigo === 'SAOC-400' || res.codigo === 'SAOC: 500')
						notice(JSON.parse(JSON.stringify(res.mensaje)));
					else {
						notice(
							'Resolucion/Recomendacion actualizada con éxito',
							'success'
						);
						onreturn();
					}

					setLoading(false);
				})
				.catch((e) => {
					setLoading(false);
					if (isDev) {
						if (e.response.data.mensaje === undefined) {
							notice('Ha ocurrido un error con su petición');
						} else
							notice(JSON.parse(JSON.stringify(e.response.data.mensaje)));
					} else notice('Ha ocurrido un error con su petición');
				});
		} else {
			topicAPI
				.post({ ...resOrRecFlag })
				.then((res) => {
					if (res.codigo === 'SAOC-400' || res.codigo === 'SAOC: 500')
						notice(JSON.parse(JSON.stringify(res.mensaje)));
					else {
						notice(
							'Resolucion/Recomendacion fue asignada correctamente',
							'success'
						);
						clearForm();
					}
					setLoading(false);
				})

				.catch((e) => {
					if (isDev) {
						if (e.response.data.mensaje === undefined) {
							notice('Ha ocurrido un error con su petición');
						} else
							notice(
								JSON.parse(JSON.stringify(e.response.data.mensaje)),
								'warning'
							);
					} else notice('Ha ocurrido un error con su petición');
					setLoading(false);
				});
		}
	};

	const handleChange = ({ target }) => {
		const { name, value } = target;
		setResOrRec({ ...resOrRec, [name]: value });
		if (name === 'responsible' || name === 'accompaniment') {
			let selectedField = 0;
			if (name === 'responsible') {
				selectedField = 1;
			} else if (name === 'accompaniment') {
				selectedField = 2;
			}
			let institutionsSelec = value;
			let arrayInstitutions = [];
			institutionsSelec.forEach((item) => {
				arrayInstitutions.push(item.value);
			});
			getUsersInstitutions(arrayInstitutions, selectedField);
		}

		let dataResolution = { ...resOrRec };
		if (name === 'filingDate') {
			const newDeadline = new Date(value);
			newDeadline.setDate(newDeadline.getDate() - 14);
			dataResolution.deadline = newDeadline;
			dataResolution.filingDate = value;
			setResOrRec(dataResolution);
		}
		if (name === 'estatus')
			if (value === 'A' || value === 'AT') setStatus(true);
			else setStatus(false);
	};

	const onClickSendArchivos = (role) => {
		role = role.toUpperCase();

		let estatus = role === 'ENLACE' ? 'EP' : 'AT';
		estatus = role === 'RESPONSABLE DE SEGUIMIENTO' ? 'APO' : estatus;
		topicAPI.enviarNotificacionResponsable(id, estatus).then((response) => {
			notice('Notificación Enviada', 'success');
			setFlagRender(true);
		});
	};
	const handleChangeFilter = ({ target }) => {
		const { name, value } = target;

		if (name === 'sessions') {
			if (value === '' || value === null) {
				setValidation(false);
			} else {
				setValidation(true);
				let newSession = datesSessions.filter(
					(session) => session.idSession === value
				);
				getPoints(value);

				if (newSession.length > 0) {
					let newDate = newSession[0].dateSession;
					resOrRec.sessionDate =
						newDate.split('-').reverse().join('-') + ' 00:00:00';
				}
			}
		}

		if (name === 'organ') {
			setOrganID(value);

			filters.sessions = null;
			resOrRec.filingDate = null;
			resOrRec.sessionDate = null;
			resOrRec.deadline = null;
			resOrRec.notificationDate = null;
			if (filters.month !== '') {
				setSesPrevious([]);
				getPreviousSessions(value, filters.year, filters.month);
			}
		}

		if (name === 'month') getPreviousSessions(organID, filters.year, value);
		if (name === 'year')
			if (value > new Date().getFullYear()) {
				alert('El año no puede ser mayor al año actual');
				return;
			} else getPreviousSessions(organID, value, filters.month);

		setFilters({ ...filters, [name]: value });
	};

	const clearForm = () => setResOrRec(defaultResOrRec);
	const style = {
		position: 'fixed',
		top: '8%',
		left: '12%',
		right: '0',
		bottom: '0',
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '80vw',
		height: '85vh',
		zIndex: 1000,
	};
	const backdrop = {
		position: 'fixed',
		top: '0',
		left: '0',
		right: '0',
		bottom: '0',
		width: '100vw',
		height: '100vh',
		backgroundColor: ' rgba(0, 0, 0, 0.5)',
		zIndex: 1,
	};

	return (
		<Dialog open={id !== null ? true : false} onClose={onreturn}>
			<div style={style}>
				<PageLayout title="Resolución o Recomendación">
					<div
						onClick={onreturn}
						style={{
							position: 'absolute',
							top: '2%',
							right: '2%',
							cursor: 'pointer',
						}}
					>
						<CloseIcon />
					</div>
					<UtilInputs
						formValues={filters}
						inputValues={filterForm(organs, sessionsPrevious, disabledInputs)}
						onValuesChange={handleChangeFilter}
					/>
					{validation === false ? (
						'  '
					) : (
						<>
							<UtilInputs
								formValues={resOrRec}
								inputValues={highResForm(
									institutions,
									recipientsResponsible,
									recipientsAccompaniment,
									points,
									disabledInputs,
									disabledDates,
									trackSchedule,
									status
								)}
								onValuesChange={handleChange}
							/>
							{id !== null && resOrRec.estatus !== 'PE' ? (
								<div className="mt-lg-10">
									<h3 className="col-auto mr-auto ">Documentos</h3>
									<Grid container className={classes.root} spacing={10}>
										{items.length > 0 ? (
											<TablaDocumentos
												onClickEnviar={onClickSendArchivos}
												items={items}
												inpustfile={inpustfile}
												setFlagRender={setFlagRender}
											/>
										) : (
											<></>
										)}
									</Grid>
								</div>
							) : (
								<></>
							)}
							<div className="d-flex mt-5">
								<p className="ml-5">
									El sistema enviará un correo al titular de la U.
									Administrativa Responsable y al Enlace la notificación
									vía correo electrónico.
								</p>
							</div>

							<Grid
								className={classes.containerButtons}
								container
								spacing={2}
							>
								<Grid
									className={classes.subContainerButtons}
									item
									md={12}
								>
									{action_buttons(
										() => createData(id ? true : false),
										clearForm,
										onreturn,
										disabledInputs
									).map((button) =>
										button != null ? (
											<CustomButton
												key={button.title}
												mainText={button.title}
												color={button.color}
												onClick={button.onClick}
												disabled={button.disabled}
												className={button.className}
											/>
										) : (
											<></>
										)
									)}
								</Grid>
							</Grid>
						</>
					)}
				</PageLayout>
			</div>
			<div style={backdrop}></div>
		</Dialog>
	);
};

export default HighResolutionView;
